﻿import React from 'react';

export function useDelayedUnmount(show: boolean, delayMs: number = 300) {
    const [shouldRender, setShouldRender] = React.useState(show);

    React.useEffect(() => {
        if (show) {
            setShouldRender(true);
        } else {
            const timer = self.setTimeout(() => setShouldRender(false), delayMs);
            return () => self.clearTimeout(timer);
        }
    }, [show, delayMs]);

    return shouldRender;
}